module.exports = __webpack_public_path__ + "img/25.0e5317bd.jpg";